// extracted by mini-css-extract-plugin
export default {"Title":"typeface_Title__0QiCb","TitleItalics":"typeface_TitleItalics__TQgvg"};